module.exports = __webpack_public_path__ + "static/img/certificateGYL.18b7265a.jpg";